export type PlayExperience = 'solo' | 'host' | 'local' | 'lobby' | 'online'

export const MATCHMAKING_ENABLED = import.meta.env.VITE_MATCHMAKING_ENABLED === 'true'
export const MATCHMAKING_UNAVAILABLE =
  'Online matchmaking is currently unavailable. Try Pass & Play or Play with Friends.'

export const playExperiences = {
  solo: {
    title: 'Solo Play',
    description: 'Ten items. Five guesses. Can you rank them all?',
    badge: 'Solo',
    mode: 'single',
    multiMode: 'local',
    tab: 'daily',
  },
  host: {
    title: 'Host a Game',
    description: 'You hold the answers. Give hints and let everyone compete.',
    badge: 'In person',
    mode: 'host',
    multiMode: '',
    tab: 'random',
  },
  local: {
    title: 'Pass & Play',
    description: 'One device, two sides. Take turns and score the most points.',
    badge: 'Same device',
    mode: 'multi',
    multiMode: 'local',
    tab: 'random',
  },
  lobby: {
    title: 'Play with Friends',
    description: 'Create or join a private online lobby. Play team versus team.',
    badge: 'Separate devices',
    mode: 'multi',
    multiMode: 'online',
    tab: 'online',
  },
  online: {
    title: 'Online Match',
    description: 'Challenge another player and compete for trophies.',
    badge: 'Online',
    mode: 'multi',
    multiMode: 'online',
    tab: 'online',
  },
} as const

export const experiencePath = (experience?: PlayExperience) =>
  experience ? `/play/${experience}` : '/'

export function resolvePlayEntry(
  routeMode?: string,
  joinCode?: string,
  enabled = MATCHMAKING_ENABLED
): {
  experience?: PlayExperience
  redirect?: string
  message?: string
} {
  if (joinCode) return { experience: 'lobby', redirect: '/play/lobby' }
  if (!routeMode) return {}
  if (routeMode === 'multi') return { experience: 'local', redirect: '/play/local' }
  if (routeMode === 'online' && !enabled)
    return { redirect: '/', message: MATCHMAKING_UNAVAILABLE }
  if (Object.prototype.hasOwnProperty.call(playExperiences, routeMode))
    return { experience: routeMode as PlayExperience }
  return { redirect: '/' }
}
